import { Component,Input } from '@angular/core';

@Component({
	selector: 'app-most-popular-products',
	templateUrl: './most-popular-products.component.html',
	styleUrls: ['./most-popular-products.component.scss']
})
export class MostPopularProductsComponent {
	@Input() purchasesData = [
		{
			name: 'Shoes',
			price: '5,903.30 SAR',
			sold: '1,145 sold',
			percent: '-2.9%',
			iconColor: '#FF0000',
			period: 'since last month',
			img: './images/analyticIMG.png'
		},
		{
			name: 'Shirt',
			price: '3,450.00 SAR',
			sold: '890 sold',
			percent: '+1.5%',
			iconColor: '#18F121',
			period: 'since last month',
			img: './images/analyticIMG.png'
		},
		{
			name: 'Bag',
			price: '2,380.00 SAR',
			sold: '580 sold',
			percent: '-0.8%',
			iconColor: '#FF0000',
			period: 'since last month',
			img: './images/analyticIMG.png'
		}
	];

	@Input() clicksData = [
		{
			name: 'Shoes',
			price: '5,903.30 SAR',
			clicks: '4,374 clicks',
			percent: '+2.9%',
			iconColor: '#18F121',
			period: 'since last month',
			img: './images/analyticIMG.png'
		},
		{
			name: 'Shirt',
			price: '3,450.00 SAR',
			clicks: '2,145 clicks',
			percent: '-1.2%',
			iconColor: '#FF0000',
			period: 'since last month',
			img: './images/analyticIMG.png'
		},
		{
			name: 'Bag1',
			price: '2,380.00 SAR',
			clicks: '1,298 clicks',
			percent: '+0.5%',
			iconColor: '#18F121',
			period: 'since last month',
			img: './images/analyticIMG.png'
		}
	];

	ngOnInit() {
		console.log('Dummy data loaded:', this.clicksData);
	}

	onImgError(item: any) {
		item.img = 'images/no-image.png';
	}
}
